import { render, staticRenderFns } from "./ProductDocumentation.vue?vue&type=template&id=098a61a8&scoped=true&"
import script from "./ProductDocumentation.vue?vue&type=script&lang=js&"
export * from "./ProductDocumentation.vue?vue&type=script&lang=js&"
import style0 from "./ProductDocumentation.vue?vue&type=style&index=0&id=098a61a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098a61a8",
  null
  
)

export default component.exports